/** @param {Record<string, unknown>} a */
export function summarizeMailboxProcessingAction(a, t) {
  if (!a || typeof a !== "object") return JSON.stringify(a);
  const typ = a.type;
  switch (typ) {
    case "ai_classification":
      return t("microsoft.ai_mailboxes.processing_log.sum.ai_classification", {
        category: a.category || "—",
        source: a.source || "?",
        confidence: a.confidence ?? "—",
      });
    case "forward_to":
      if (a.dry_run) {
        return t("microsoft.ai_mailboxes.processing_log.sum.forward_dry", { to: a.to || "?" });
      }
      if (a.sent) {
        return t("microsoft.ai_mailboxes.processing_log.sum.forward_sent", { to: a.to || "?" });
      }
      return t("microsoft.ai_mailboxes.processing_log.sum.forward_failed", {
        to: a.to || "?",
        error: a.error || "",
      });
    case "move_processed_mail":
      if (a.dry_run && a.would_move) {
        return t("microsoft.ai_mailboxes.processing_log.sum.move_dry", {
          target: a.custom_folder_from_routing ? ` → ${a.custom_folder_from_routing}` : "",
        });
      }
      if (a.applied) {
        return t("microsoft.ai_mailboxes.processing_log.sum.move_ok", { folder: a.folder || "?" });
      }
      return t("microsoft.ai_mailboxes.processing_log.sum.move_failed", { error: a.error || "" });
    case "skip_case":
      return a.applied
        ? t("microsoft.ai_mailboxes.processing_log.sum.skip_case")
        : t("microsoft.ai_mailboxes.processing_log.sum.skip_case_unused");
    case "archive":
      if (a.dry_run || a.would_archive) {
        return t("microsoft.ai_mailboxes.processing_log.sum.archive_dry");
      }
      if (a.applied) {
        return t("microsoft.ai_mailboxes.processing_log.sum.archive_ok", {
          folder: a.folder ? ` → ${a.folder}` : "",
        });
      }
      return t("microsoft.ai_mailboxes.processing_log.sum.archive_failed", {
        error: a.error || "",
      });
    case "ai_routing_skipped":
      return t("microsoft.ai_mailboxes.processing_log.sum.ai_routing_skipped", {
        reason: a.reason || "",
      });
    case "inbound_unknown_fallback":
      if (a.applied) {
        return t("microsoft.ai_mailboxes.processing_log.sum.unknown_fallback_sent", {
          to: a.to || "?",
        });
      }
      if (a.would_forward) {
        return t("microsoft.ai_mailboxes.processing_log.sum.unknown_fallback_dry", {
          to: a.to || "?",
        });
      }
      return t("microsoft.ai_mailboxes.processing_log.sum.unknown_fallback_failed", {
        error: a.error || "",
      });
    case "inbound_system_copy":
      if (a.detail === "forward") {
        return t("microsoft.ai_mailboxes.processing_log.sum.system_copy_forward", {
          to: a.to || "?",
        });
      }
      if (a.detail === "archive") {
        return t("microsoft.ai_mailboxes.processing_log.sum.system_copy_archive", {
          folder: a.folder || "",
        });
      }
      if (a.detail === "already_applied") {
        return t("microsoft.ai_mailboxes.processing_log.sum.system_copy_already");
      }
      return t("microsoft.ai_mailboxes.processing_log.sum.system_copy_none");
    default:
      if (a.error) {
        return t("microsoft.ai_mailboxes.processing_log.sum.generic_error", {
          type: typ || "?",
          error: a.error,
        });
      }
      if (a.applied === false) {
        return t("microsoft.ai_mailboxes.processing_log.sum.generic_not_applied", { type: typ || "?" });
      }
      return typ || JSON.stringify(a);
  }
}
